<template>
  <div class="sp-provider-insurance-plans-modal" :class="classModifiers">
    <sp-button class="sp-provider-insurance-plans-modal__trigger" :variant="triggerVariant" @click="openModal">
      {{ triggerLabelText }}
    </sp-button>

    <sp-modal
      class="sp-provider-insurance-plans-modal__modal"
      :open="open"
      :width="modalWidth"
      :height="modalHeight"
      :modal-title="modalTitle"
      no-scrollable-content
      @close="open = false"
    >
      <InsurancePlanFilter
        v-if="hasOpened"
        class="sp-provider-insurance-plans-modal__filter"
        v-bind="insurancePlanFilterProps"
      />
    </sp-modal>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { props as insurancePlansModalProps } from "./props.js";
import { useBreakpoints } from "#ce/composables/useBreakpoints";
import { formAssociatedHost } from "#ce/framework/utils";
import InsurancePlanFilter from "#ce/apps/shared/filters/insurance-plan/components/InsurancePlanFilter.ce.vue";

// The nested InsurancePlanFilter attaches ElementInternals via useForm() on this host.
defineOptions(formAssociatedHost());

const props = defineProps(insurancePlansModalProps);

const { ltModifiers } = useBreakpoints();

const open = ref(false);
const hasOpened = ref(false);

const searchBarPlanThreshold = 10;
const modalWidth = "var(--sp-comp-provider-insurance-plans-modal-modal-width, min(40ch, calc(100vw - 2rem)))";
const modalHeight = "var(--sp-comp-provider-insurance-plans-modal-modal-height, fit-content)";
const filterMaxHeight = "var(--sp-comp-provider-insurance-plans-modal-filter-max-height, calc(90vh - 6rem))";

const triggerLabelText = computed(() => {
  if (props.triggerLabel != null) {
    return props.triggerLabel;
  }

  if (props.acceptedPlansCount === 1) {
    return "View 1 Accepted Plan";
  }

  return `View All ${props.acceptedPlansCount} Accepted Plans`;
});

const insurancePlanFilterProps = computed(() => ({
  hideProgressBar: true,
  hideSearchBar: props.acceptedPlansCount < searchBarPlanThreshold,
  hideTitleBar: true,
  hidePointer: true,
  maxHeight: filterMaxHeight,
  permanent: true,
  readonly: true,
  url: props.url,
}));

const classModifiers = computed(() => [...ltModifiers.value]);

function openModal() {
  hasOpened.value = true;
  open.value = true;
}
</script>

<style lang="scss">
:host {
  display: block;
}

.sp-provider-insurance-plans-modal {
  &__filter {
    --sp-comp-popup-min-height: 0;
  }

  &__modal {
    --modal-card-padding: 0;
    --sp-comp-modal-card-height: auto;
    --sp-comp-modal-header-padding-inline: var(--sp-ref-spacing-8);
  }

  &.--lt-sm-screen {
    width: var(--sp-comp-provider-insurance-plans-modal-width-sm, 100%);

    .sp-provider-insurance-plans-modal__trigger {
      --button-width: var(--sp-comp-provider-insurance-plans-modal-trigger-width-sm, 100%);
    }
  }
}
</style>
